import React from 'react';
import { ArrowUpRight, BookOpen, Heart } from 'lucide-react';
import { getPublicBookHref } from '../lib/bookDestination';
import './HomeBookCard.css';

export const HOME_BOOK_DEFAULTS = {
  enabled: true,
  title: '',
  author: '',
  coverImage: '',
  authorImage: '',
  sealText: 'Written from lived experience',
  eyebrow: 'A COMPANION FOR YOUR JOURNEY',
  subtitle: 'Feel informed. Prepared. Supported.',
  description: 'The essential guidebook to surgery, recovery & breast implant illness. Written from lived experience, with you in mind.',
  buttonText: 'Get the book',
  purchaseUrl: ''
};

function imageHref(value) {
  return value?.startsWith('/api/') ? `${process.env.REACT_APP_BACKEND_URL || ''}${value}` : value;
}

function safeHref(value) {
  if (typeof value !== 'string') return '';
  const url = value.trim();
  return /^https?:\/\//i.test(url) || /^\/(?!\/)/.test(url) ? url : '';
}

export default function HomeBookCard({ book, settings, photo }) {
  const card = { ...HOME_BOOK_DEFAULTS, ...settings };
  const title = card.title || book.title || 'Explant';
  const author = card.author || book.author || 'Lindsey Mayr';
  const authorPhoto = card.authorImage || photo;
  const href = safeHref(card.purchaseUrl) || safeHref(book.purchase_link) || safeHref(getPublicBookHref(book)) || '/book';
  const external = /^https?:\/\//i.test(href);
  return (
    <article className="home-book-card" aria-labelledby="home-book-title" data-testid="home-book-card">
      <div className="home-book-card__topline"><BookOpen size={15} aria-hidden="true" /><span>{card.eyebrow}</span><span className="home-book-card__dot" aria-hidden="true" /></div>
      <div className="home-book-card__stage">
        <span className="home-book-card__orbit" aria-hidden="true" />
        <span className="home-book-card__orbit home-book-card__orbit--two" aria-hidden="true" />
        <div className="home-book-card__book">
          <img src={imageHref(card.coverImage || book.coverImage) || '/book-cover.jpg'} alt={`${title} by ${author} — book cover`} fetchPriority="high" width="600" height="900" onError={e => { e.currentTarget.onerror = null; e.currentTarget.src = '/book-cover.jpg'; }} />
        </div>
        <div className="home-book-card__seal"><Heart size={16} aria-hidden="true" /><span>{card.sealText}</span></div>
      </div>
      <div className="home-book-card__content">
        <div className="home-book-card__byline">{authorPhoto && <img src={imageHref(authorPhoto)} alt="" width="30" height="30" />}<span>By {author}</span></div>
        <h2 id="home-book-title">{title}</h2>
        <p className="home-book-card__subtitle">{card.subtitle}</p>
        <p className="home-book-card__description">{card.description}</p>
        <a className="home-book-card__purchase" href={href} {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
          <span>{card.buttonText || HOME_BOOK_DEFAULTS.buttonText}</span><ArrowUpRight size={21} aria-hidden="true" />
          {external && <span className="sr-only"> (opens in a new tab)</span>}
        </a>
      </div>
    </article>
  );
}
